import React from 'react';
import {UncontrolledTooltip} from 'reactstrap';
import styled from 'styled-components';
import {convertSpeedTo, nomenclatureSpeedOf} from '../../../../helpers/conversions';
import Velocity from './velocity';
import {useIntl} from 'react-intl';
import useStore from 'src/hooks/use-store';

const Style = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  background-color: ${({theme}) => theme};
  color: white;
  line-height: 0.9rem;
  padding: 0.4rem 1rem;
  width: 83%;
  position: relative;

  > h4 {
    font-weight: bold;
    margin-bottom: 0.1rem;
    max-width: 90%;
  }
`;

const Header = ({
  currentPosition = {},
  name,
  uniqueId,
  attributes,
  server,
  theme,
}) => {
  const intl = useIntl();
  const hasPosition = currentPosition?.latitude !== undefined && currentPosition?.longitude !== undefined;
  const {store} = useStore();
  const {session} = store;

  const {
    hasUserSpeedUnit,
    hasServerSpeedUnit,
  } = {
    hasUserSpeedUnit: session.attributes && session.attributes.speedUnit,
    hasServerSpeedUnit: server && server.attributes && server.attributes.speedUnit,
  };

  const _speedUnit = hasUserSpeedUnit ?
    session.attributes.speedUnit :
    hasServerSpeedUnit ?
      server.attributes.speedUnit :
      undefined;

  const {
    speedValue,
    speedUnit,
  } = {
    speedValue: convertSpeedTo(
      currentPosition?.speed,
      _speedUnit,
    ),
    speedUnit: nomenclatureSpeedOf(_speedUnit),
  };

  return (
    <Style id="header" theme={theme}>
      <h4 className="text-truncate text-left">{name}</h4>
      <small>ID: {uniqueId}</small>
        <small className="text-truncate w-75 pointer text-left" id="lonlat">
        {hasPosition ?
          `${currentPosition?.latitude}º, ${currentPosition?.longitude}º` :
          intl.formatMessage({id: 'notAvailable'})
        }
        </small>
      {hasPosition && (
        <UncontrolledTooltip placement="right" target="lonlat">
          {currentPosition?.latitude}º, {currentPosition?.longitude}º
        </UncontrolledTooltip>
      )}
      <Velocity
        speed={speedValue}
        // limit={
        //   attributes &&
        //   server.attributes &&
        //   convertSpeedTo(attributes.speedLimit, server.attributes.speedUnit)
        // }
        unit={speedUnit}
      />
    </Style>
  );
};

export default Header;
